<template>
  <div id="cepillos" class="tab-detalle has-text-left">
    <h3 class="has-text-weight-bold is-red is-uppercase">
      {{ this.$i18n.t('general.Brushes') }}
      <b-field>
        <b-switch v-model="cepillosTipoSelector"

                  type="is-primary"
                  v-if="selected_opcion == 'Rayado' || selected_opcion == 'Bandas'"
        >
          {{ cepillosTipoSelector == false ? $i18n.t('general.basicSelectorInvert') : $i18n.t('general.advancedSelector') }}
        </b-switch>
      </b-field>

    </h3>


    <div class="scrolling-wrapper" v-if="opciones.length > 0">
      <div :class="{opcion: true, 'selected': selected_opcion == parte ? true : false}" v-for="parte in opciones"
           :key="'rodillo_tipo_'+parte">
        <b-button @click="selTipoRodillo(parte)">{{ $i18n.t('general.' + parte) }}</b-button>
      </div>
    </div>
    <p class="is-size-6 mt-2">{{ this.$i18n.t('general.ClickSelectColor') }}</p>
    <div class="colores has-text-left">
      <div class="colores has-text-centered pb-0 pt-0">
         <span v-for="(col,index) in ncolores" :key="'colconfig_'+col">
            <b-button :type="'is-'+selected_color_advanced[index]" @click="activateModalColor(index)">{{ selected_color_advanced[index] }}</b-button>
          </span>

      </div>
      <div class="colores" v-if="cepillosTipoSelector == true">
        <p class="is-size-6">{{ this.$i18n.t('general.ClickSelectColorPatron') }}</p>
        <p>
          <b-button v-for="(teja) in tejas" :key="'cepillo_teja_'+teja.orden+'_'+teja_serial" :type="'is-'+teja.color"
                    @click="selTeja(teja.orden)">{{ teja.color }}
          </b-button>
        </p>

      </div>
    </div>
    <b-modal
        v-model="isColoresModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        :aria-label="this.$i18n.t('general.ColorSelector')"
        aria-modal
        custom-class="selector-colores">
      <div class="card">
        <div class="card-content has-text-centered">
          <div class="content pb-2">
            <h4 class="is-size-5 has-text-weight-normal is-gris">{{ this.$i18n.t('general.SelectColor') }}</h4>
            <!--<a class="close has-text-right is-size-7">
              <span class="has-text-centered"><img svg-inline class="icon" src="../assets/img/icon-close.svg" alt="cerrar" /></span>
            </a>-->
            <div class="colores has-text-centered">
              <b-button v-for="(color) in colores_local" :key="'color_cepillo_'+color.ral" :type="'is-'+color.codigo"
                        @click="selColorAdvanced(color.ral,color.codigo,-1)" :focused="color === selected_color">
                {{ color.codigo }}
              </b-button>
            </div>
            <b-button type="is-ghost" expanded class="py-4 is-size-5" @click="isColoresModalActive = false;selected_teja=null">
              {{ this.$i18n.t('general.Cancel') }}
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>


export default {
  name: "selCepillos",
  props: ["configuracion", "colores"],
  data() {
    return {
      isColoresModalActive: false,
      selected_opcion: null,
      selected_color: null,
      selected_teja: null,
      lopciones: null,
      tejasactivas: [],
      teja_serial: 0,


      cepillosTipoSelector: false,
      ncolores: 2,
      choosingColor: -1,
      selected_color_advanced: [],
      colores_local: [],
      colores_backup: [],
      patrones: []




    }
  },
  mounted() {
    this.colores_backup = this.colores
    this.colores_local = this.colores



    if (!this.$store.getters.getIsConfigFromHash) {
      this.selected_opcion = this.configuracion.find(elem => elem.default == true).codigo
      this.$store.commit('setSolicitar',true)

      this.$emit('registrar-cambio', {
        'parte': 'cepillo',
        cambio: 'tipo',
        valor: this.selected_opcion,
        'tejas': this.tejas,
        solicitar: false
      })
    } else {
      this.selected_opcion = this.$store.getters.getTipoRodillos
    }
    if (this.configuracion) {
      this.initColors()
    }


  },


  computed: {

    opciones: function () {
      return typeof this.configuracion !== 'undefined' ? this.configuracion.map(elem => {
        return elem.codigo
      }) : []
    },
    tejas: function () {
      let s = this.configuracion.find(elem => elem.codigo == this.selected_opcion)
      return typeof s === 'object' ? s.tejas : []
    },
    variaciones: function () {
      return this.$store.getters.getVariaciones;
    },
    isconfigfromhash: function () {
      return this.$store.getters.getIsConfigFromHash
    },
    coloresfiltered: function () {
      return this.colores.filter(item => this.selected_color_advanced.includes(item.codigo))


    },


  },
  methods: {
    selColor(color, codigo) {
      console.log('Cepillos: selColor '+this.tejas)
      this.selected_color = color
      this.tejas.find(elem => elem.orden == this.selected_teja).color = codigo

      this.teja_serial += 1
      this.isColoresModalActive = false
      this.$store.commit('setSolicitar',true)

      this.$emit('registrar-cambio', {
        'parte': 'cepillo',
        cambio: 'color',
        'opcion': this.selected_opcion,
        teja: this.selected_teja,
        valor: color
      })
    },
    selColorAdvanced(color_ral, color_codigo, ncolor = -1) {

      console.log('Cepillos: selColorAdvanced '+JSON.stringify(this.tejas))
      let numcolor = 0
      if (ncolor == -1) {
        numcolor = this.choosingColor
      } else {
        numcolor = ncolor

      }


      if (this.selected_opcion == 'Liso') {
        this.configuracion[0].tejas[0].color = color_ral
      } else {

        let indx_patron = this.configuracion.findIndex(el => el.codigo == this.selected_opcion)


        if (this.selected_teja !== null && this.selected_teja > 0){
          let indx = this.selected_teja -1
          if (this.patrones[indx_patron][0].tejas_indice.includes(indx)){
            this.patrones[indx_patron][0].tejas_indice= this.patrones[indx_patron][0].tejas_indice.filter(el => {return el !== indx})
            this.patrones[indx_patron][1].tejas_indice.push(indx)
          }else{
            this.patrones[indx_patron][1].tejas_indice= this.patrones[indx_patron][1].tejas_indice.filter(el => {return el !== indx})
            this.patrones[indx_patron][0].tejas_indice.push(indx)
          }
          this.configuracion[indx_patron].tejas[indx].color = color_ral
          this.selected_teja = null

        }else{

          if (numcolor == 0) {
            this.patrones[indx_patron][0].tejas_indice.map(el => {
              this.configuracion[indx_patron].tejas[el].color = color_ral
            })

          } else {
            this.patrones[indx_patron][1].tejas_indice.map(el => {
              this.configuracion[indx_patron].tejas[el].color = color_ral
            })

          }
        }


      }
      this.selected_color_advanced[numcolor] = color_codigo
      this.$store.commit('setSolicitar',true)
      this.$emit('registrar-cambio', {'parte': 'cepillo', cambio: 'tipo', valor:this.selected_opcion, 'tejas': this.tejas,'config': {'colores': this.selected_color_advanced,'tipo': this.selected_opcion,'mode': this.cepillosTipoSelector}})
      this.choosingColor = -1
      this.isColoresModalActive = false
    },
    selTeja(teja) {
      this.selected_teja = teja

      this.colores_local = this.colores.filter(item => {
        return this.selected_color_advanced.includes(item.codigo)
      })

      this.isColoresModalActive = true

    },
    selSoloTeja(teja) {
      this.selected_teja = teja

    },
    selTipoRodillo(parte) {
      if (this.selected_opcion !== parte) {
        if (parte =='Liso'){
          this.cepillosTipoSelector = false
        }
        this.selected_opcion = parte
        this.colorearCambioTipo(parte)
      }


    },
    getSelColorTeja(orden) {

      return this.tejasactivas[orden]
    },
    mostrarSelectorColorBasico(){

      this.colores_local = this.colores
      this.$nextTick()
      this.isColoresModalActive = true
    },
    activateModalColor(col) {
      this.selected_teja = null
      this.colores_local = this.colores_backup
      this.choosingColor = col
      this.isColoresModalActive = true

    },
    colorearCambioTipo(opcion) {


      if (opcion == 'Liso') {
        let color = this.colores.find(e => e.codigo == this.selected_color_advanced[0])
        if (typeof color !== 'undefined'){
          this.selColorAdvanced(color.ral, this.selected_color_advanced[0], 0)
        }

      } else {
        let color0 = this.colores.find(e => e.codigo == this.selected_color_advanced[0])
        if (typeof color0 !== 'undefined'){
          this.selColorAdvanced(color0.ral, this.selected_color_advanced[0], 0)
        }

        let color1 = this.colores.find(e => e.codigo == this.selected_color_advanced[1])
        if (typeof color1 !== 'undefined'){
          this.selColorAdvanced(color1.ral, this.selected_color_advanced[1], 1)
        }


      }
    },
    initColors() {

      let i = 0;
      //this.selected_color_advanced = []
      let configuracion = this.configuracion.find(config => config.codigo == this.selected_opcion)
      //Inicializamos patrones
      this.patrones = this.configuracion.map(el =>  el.patron)


      if (this.selected_opcion == 'Liso') {
        this.ncolores = 1
      } else {
        this.ncolores = 2
      }

      for (i = 0; i < this.ncolores; i++) {

        this.selected_color_advanced[i] = this.selected_color_advanced[i] || configuracion.patron[i].color


      }



    },
    coloresRALToCodigo(color){

      if (color!=='' && (color.startsWith('RAL') || color.startsWith('PANT'))){

        let valor = this.colores.find(el => el.ral == color)
        if (valor){

          return valor.codigo
        }else{
          return ''
        }
      }else{
        return color
      }

    }

  },
  watch: {

    selected_opcion: function () {
      this.initColors()




    },

    variaciones: function (newV) {

      this.actualizando = true
      if (typeof newV !== 'undefined') {

        //let v = this.variaciones.find(v => v.parte == 'cepillo' && v.cambio == 'color')
        let f = this.variaciones.filter(v => v.parte == 'cepillo' && v.cambio == 'color')
        if (f.length > 0) {
          f.forEach(v => {
            if (typeof v == 'object') {
              let teja = this.tejas.find(elem => elem.orden == v.teja)

              if (typeof teja !== 'undefined') {
                teja.color = this.colores.find(c => c.ral == v.valor).codigo
              }

            }
          })
        }


        let t = this.variaciones.find(v => v.parte == 'cepillo' && v.cambio == 'tipo')

        if (typeof t == 'object') {

          if (t.config && typeof t.config =='object'){
            this.selected_color_advanced = t.config.colores
            this.cepillosTipoSelector = t.config.mode
            this.selected_opcion = t.config.tipo


            //console.log ('Procesamos variaciones Cepillos....')

            var indx_patron = this.configuracion.findIndex(el => el.codigo == this.selected_opcion)
            this.configuracion[indx_patron].tejas = t.tejas

            if (indx_patron > 0){
              //console.log(indx_patron+'||'+t.config.colores[0]+'||'+t.config.colores[1])
              this.patrones[indx_patron][0].color = t.config.colores[0]
              this.patrones[indx_patron][1].color = t.config.colores[1]



              let patronConf0 = t.tejas.map((el,i)=>{
                let c = this.colores.find(c => c.codigo == el.color)
                if(c && c.codigo == t.config.colores[0]){ return i} }).filter((el) => { return typeof el !=='undefined'})
              let patronConf1 = t.tejas.map((el,i)=>{
                let c = this.colores.find(c => c.codigo == el.color)
                if(c && c.codigo == t.config.colores[1]){ return i} }).filter((el) => { return typeof el !=='undefined'})


              if (patronConf0.length > 0){
                this.patrones[indx_patron][0].tejas_indice = patronConf0
              }

              if (patronConf1.length > 0){
                this.patrones[indx_patron][1].tejas_indice = patronConf1
              }


            }else{
              this.patrones[indx_patron][0].color = t.config.colores[0]
              let patronConf0 = t.tejas.map((el,i)=>{
                let c = this.colores.find(c => c.codigo == el.color)
                if(c && c.codigo == t.config.colores[0]){ return i} }).filter((el) => { return typeof el !=='undefined'})

              if (patronConf0.length > 0){
                this.patrones[indx_patron][0].tejas_indice = patronConf0
              }


            }





          }
          t.tejas.map(el =>{
            let teja = this.tejas.find(elem => elem.orden == el.orden)
            if (typeof teja !== 'undefined') {
              let tt = this.colores.find(c => c.ral == el.color)
              if (typeof tt !== 'undefined'){

                teja.color =tt.codigo
                /*if (tt.codigo == this.patrones[indx_patron][0].color ){
                  this.patrones[indx_patron][0].tejas_indice.push(el.orden-1)
                }else{
                  this.patrones[indx_patron][1].tejas_indice.push(el.orden-1)
                }*/
              }

            }

          })




          if (t.valor !== this.selected_opcion) {

            this.selected_opcion = t.valor
          }
        }
      }
      this.actualizando = false


    },
    isconfigfromhash: function (newv) {
      if (newv) {
        this.selected_opcion = this.$store.getters.getTipoRodillos;
      }
    },




  }


}
</script>

<style scoped>

</style>
